import { IAHU_Optimizer } from './types'
import { useSetObjectValue } from '../../../../hooks/useSetObjectValue';
import { ListPanelWrapper } from '../../../components/ListPaneWrapper';
import { Input } from 'baseui/input';
import { useStyletron } from 'baseui';
import { ValueDisplay } from '../../../components/ValueDisplay';

export function ListPanel(props: IAHU_Optimizer) {
    return (
        <ListPanelWrapper  {...props}>
            <ValueDisplay value={props.output} dimension={'Pa'}></ValueDisplay>
        </ListPanelWrapper>
    );
}